import {Urls} from './url'
// webscoket通信用于价格相关信息推送
 let webSocket = {
    init(){
        this.WS = new WebSocket(Urls.webscoketurl);
        this.WS.onopen = function(){//开启webscoket通信
            this.send("priceAll");
        };
        this.WS.onmessage = function(evt){
            try{
                const res =  JSON.parse(evt.data)
                if(res !=={}){
                    localStorage.setItem('priceAll',evt.data)
                }
            }catch(res){
                 console.log(res)
            }
        };
        this.WS.onerror = (res)=>{
            console.log('连接错误,请刷新页面')
        }
        this.WS.onclose = function(res){
            this.close()
        }
    },
    //关闭连结回调
    onClose(){
      this.WS.onclose()
    }
  }
  export default webSocket;


// WEBPACK FOOTER //
// ./src/util/webscoket.js